import { ErrorsDict, IFormErrorService } from './../../services/form_error_service/form_error_service';
import { IAccount } from './../../../../lib/user_app/builders/account_builder';
import { AccountDatasource } from './../../../../lib/user_app/datasources/account_datasource';
import { ILog } from './../../types';
import { IServerResponse } from './../../interfaces/server_response';
import { ContactCounselorFormModel } from './contact_counselor_form_model';
import { IPhxStateService } from 'utility-ng-configuration';
import { ICommand } from 'core-ts-types';

export class ContactCounselorModalController {
  public letter: ContactCounselorFormModel;
  private open: boolean = true;
  private errors: ErrorsDict;
  public validations: {
    email: RegExp;
  };

  constructor(
    public $state: IPhxStateService,
    private log: ILog,
    private contactCounselorFormModel: ContactCounselorFormModel,
    private sendCounselorMessageCommand: ICommand,
    private ngAccountDatasource: AccountDatasource,
    private emailRegex: RegExp,
    private formErrorService: IFormErrorService
  ) {
    this._initialize();
    this.validations = {
      email: this.emailRegex
    };
  }

  private _initialize(): void {
    let account: IAccount = this.ngAccountDatasource.read();
    this.letter = _.merge(this.contactCounselorFormModel, {
      student_email: account.email,
      first_name: account.first_name,
      last_name: account.last_name
    });
  }

  submitForm(): void {
    // TODO needs integration with a global error handling policy (how do we limit error tags on one operation to 1)
    this.errors = {};
    this.sendCounselorMessageCommand(this.letter)
      .then(() => {
        this.contactCounselorFormModel.reset();
        this.log.user.success({
          content: `Your message has been sent to a counselor`,
          timeout: 10000,
          dismissOnTimeout: true,
          dismissButton: true
        });
        this.closeDialog();
      })
      .catch((res: ng.IHttpPromiseCallbackArg<IServerResponse>) => {
        this.errors = this.formErrorService(res.data!.error);
      });
  }

  openedChanged(event: any) {
    if (!event.detail.value) {
      this.$state.__goToPrevious__();
    }
  }

  closeDialog() {
    this.contactCounselorFormModel.reset();
    this.open = false;
  }
}

angular.module('capability-ng-global').controller('ngContactCounselorModalController', ContactCounselorModalController);



// WEBPACK FOOTER //
// ./app/lib/global/modals/contact_counselor/contact_counselor.ts